export default __webpack_public_path__ + "static/michal-malewicz@2x-69df6744b77942ae62d1a7ef5ac4b743.png";